module.exports = __webpack_public_path__ + "static/img/The Fool.09bcef9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The Fool.jpg
// module id = 1312
// module chunks = 0